<template>
    <div id="page" class="page-content">
        <div data-height="150" class="page-title-bg bg-20"><!-- image --></div>
        <div data-height="150" class="page-title-bg dark-mode-tint"><!-- contrast for dark mode --></div>
        <div data-height="150" class="page-title-bg opacity-90 bg-highlight"><!-- background color --></div>

        <div class="page-title-small color-white bottom-30">
            <h1><i class="fa fa-arrow-left back-button"></i>Buscar OT</h1>
            <a href="/dashboard" data-menu="menu-main" class="shadow-huge scale-box bg-fade-gray2-dark"
                v-bind:style="userimageurl"></a>
            <span class="bg-highlight color-white">{{ username }}<br>{{ cargo }}</span>
        </div>

        <div id='content1'>

            <div class="calendar round-small shadow-small">
                <div class="cal-header">
                    <h4 class="cal-title center-text uppercase bolder bg-aqua-light"><a href="#" class="color-white">{{
                            sucursal }}</a></h4>
                </div>
            </div>

            <!-- Franja FIJA arriba: BUSCAR POR OT + filtros (position:fixed, debajo del header) -->
            <div ref="filtroBar" style="padding:8px 12px 10px; position: fixed; left:0; right:0; top:0; z-index: 95; background-color: #f2f2f2; box-shadow: 0 3px 5px rgba(0,0,0,0.08);">
                <!-- Fila 1: buscar por número de OT -->
                <div style="display:flex; gap:6px; margin-bottom:6px;">
                    <input type="number" v-model="datasearch" @keyup.enter="buscarOT()" placeholder="Buscar por N° de OT"
                        inputmode="numeric" pattern="[0-9]*"
                        style="flex:1; height:36px; border:1px solid #ccc; border-radius:8px; padding:0 10px; font-size:13px; background:#fff;">
                    <a href="#" @click.prevent="buscarOT()" class="button bg-blue2-dark round-small shadow-small"
                        style="height:36px; line-height:36px; padding:0 18px; margin:0; font-size:13px;">Buscar</a>
                </div>
                <!-- Fila 2: filtros -->
                <div style="display:flex; gap:6px;">
                    <select v-model="sucursalSel" @change="cambioSucursal" style="flex:1; height:36px; border:1px solid #ccc; border-radius:8px; padding:0 6px; font-size:12px; background:#fff;">
                        <option :value="0">Todas las sucursales</option>
                        <option v-for="s in listaSucursales" :key="'s'+s.COD" :value="s.COD">{{ s.DESCRIP }}</option>
                    </select>
                    <select v-model="usuarioSel" @change="aplicarFiltros" style="flex:1; height:36px; border:1px solid #ccc; border-radius:8px; padding:0 6px; font-size:12px; background:#fff;">
                        <option :value="0">Todos los usuarios</option>
                        <option v-for="u in listaUsuarios" :key="'u'+u.COD" :value="u.COD">{{ u.DESCRIP }}</option>
                    </select>
                    <select v-model="estadoSel" @change="aplicarFiltros" style="flex:1; height:36px; border:1px solid #ccc; border-radius:8px; padding:0 6px; font-size:12px; background:#fff;">
                        <option :value="0">Todos los estados</option>
                        <option v-for="e in listaEstados" :key="'e'+e.COD" :value="e.COD">{{ e.DESCRIP }}</option>
                    </select>
                </div>
            </div>

            <div id="menu-email" class="menu menu-box-bottom menu-box-detached round-medium" data-menu-height="290"
                data-menu-effect="menu-over">
                <div id="menu-emailcontent" class="content">
                    <h1 class="uppercase ultrabold top-20">Envío de Trabajos por Email</h1>
                    <form id="formemail">
                        <span id="r_txtemail" style="display:none"
                            class="bg-red2-dark center-text uppercase color-white ultrabold">Requerido</span>
                        <span id="e_txtemail" style="display:none"
                            class="bg-red2-dark center-text uppercase color-white ultrabold">El formato de e-mail es
                            incorrecto</span>
                        <div class="input-style has-icon input-style-1 input-required">
                            <span>Email</span>
                            <em>(requerido)</em>
                            <input id="txtemail" type="email" placeholder="Email">
                        </div>

                        <div class="clear"></div>
                        <a href="#" @click="enviarmailtrabajos()"
                            class="button button-full button-s shadow-large button-round-small bg-blue2-dark top-10">Enviar
                            e-mail</a>
                        <div class="top-20 bottom-20">
                            <a href="#" data-menu="salir" class="center-text font-11 color-gray2-dark">Para cancelar
                                presione aquí</a>
                        </div>
                    </form>

                </div>

                <div id="sendingmail" class="shadow-large alert alert-large alert-round-medium bg-green1-dark"
                    style="display:none">
                    <i class="fa fa-check"></i>
                    <strong class="uppercase ultrabold">Success</strong>
                    <span>Everything's okay here</span>
                    <i data-menu="salir" class="fa fa-times"></i>
                </div>

            </div>

            <div style="padding:6px 12px 4px;">
                <div v-for="(a, index) in agendaPaginada" :key="a.IN_COD_COTIZACIONVEHICULO" style="background:#fff;border-radius:14px;box-shadow:0 2px 10px rgba(0,0,0,0.07);padding:14px 16px;margin-bottom:14px;text-align:left;">

                    <!-- Estado + N° -->
                    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px;">
                        <span v-if="a.ESTADO" :style="{ background: colorEstado(a.ESTADO) }" style="color:#fff;font-weight:700;font-size:11px;letter-spacing:0.4px;text-transform:uppercase;padding:4px 12px;border-radius:20px;">{{ a.ESTADO }}</span>
                        <span style="font-weight:700;color:#333;font-size:15px;white-space:nowrap;">N° {{ a.IN_COD_COTIZACIONVEHICULO }}</span>
                    </div>

                    <!-- Patente + vehículo -->
                    <div style="font-weight:800;font-size:19px;color:#1486c4;line-height:1.15;">{{ a.PLACAPATENTE }}</div>
                    <div style="font-size:13px;color:#888;margin-bottom:8px;">{{ a.MARCA }} / {{ a.MODELO }} / {{ a.VERSION }}</div>

                    <!-- Datos -->
                    <div style="font-size:12.5px;color:#555;line-height:1.8;">
                        <div><i class="fa fa-user" style="width:16px;color:#aab;"></i> {{ a.CLIENTEAGENDA }}</div>
                        <div><i class="fa fa-calendar" style="width:16px;color:#aab;"></i> {{ a.FECHAINGRESO }} &nbsp;·&nbsp; {{ a.USUARIO }}</div>
                        <div><i class="fa fa-map-marker-alt" style="width:16px;color:#aab;"></i> {{ a.SUCURSAL }}</div>
                    </div>

                    <!-- Acciones -->
                    <div style="display:flex;flex-wrap:wrap;gap:8px;margin-top:12px;">

                            <!-- <a href="#" @click="fechaentrega(a.IN_COD_COTIZACIONVEHICULO)"
                                class="chip chip-small bg-gray1-dark" style="top:25px">
                                <i class="fas fa-calendar-check bg-magenta1-dark"></i>
                                <span class="color-black">Entrega {{ a.FECHAENTREGA}} {{ a.HORAENTREGA}}</span>
                            </a> -->

                            <!-- <a href="#" @click="enviarwhatsapp(a.CLIENTEFONO)" class="chip chip-small bg-gray1-dark"
                                style="top:25px">
                                <i class="fab fa-whatsapp bg-green2-dark"></i>
                                <span class="color-green2-dark">Whatsapp</span>
                            </a> -->

                            <a href="#" @click="VerImagenesOT(a.IN_COD_COTIZACIONVEHICULO)"
                                style="display:inline-flex;align-items:center;gap:6px;background:#f3f4f6;color:#444;font-size:12px;font-weight:600;padding:7px 12px;border-radius:10px;text-decoration:none;">
                                <i class="fas fa-image" style="color:#e0a800;"></i> Imágenes
                            </a>

                            <a href="#" @click="ImprimirOT(a.IDEXTERNO)"
                                style="display:inline-flex;align-items:center;gap:6px;background:#f3f4f6;color:#444;font-size:12px;font-weight:600;padding:7px 12px;border-radius:10px;text-decoration:none;">
                                <i class="fa fa-print" style="color:#d23b3b;"></i> Imprimir
                            </a>
                            <a href="#" @click="VerOTInterna(a.IDEXTERNO)"
                                style="display:inline-flex;align-items:center;gap:6px;background:#f3f4f6;color:#444;font-size:12px;font-weight:600;padding:7px 12px;border-radius:10px;text-decoration:none;">
                                <i class="fa fa-file" style="color:#b0306b;"></i> Cartón
                            </a>

                            <!-- <a href="#" @click="setdatamail(a.IN_COD_COTIZACIONVEHICULO,a.CLIENTEEMAIL)"
								data-menu="menu-email" class="chip chip-small bg-gray1-dark" style="top:25px">
								<i class="fa fa-envelope bg-blue2-dark">&nbsp; {{ a.NUMEROENVIOSEMAIL }}</i>
								<span class="color-black">Enviar trabajos</span>
							</a>

							<a href="#"
								@click="setdatawhatsapp(a.IN_COD_COTIZACIONVEHICULO,a.IN_COD_USUARIOAGENDA,a.CLIENTEFONO)"
								data-menu="menu-whatsapp" class="chip chip-small bg-gray1-dark" style="top:25px">
								<i class="fab fa-whatsapp bg-green2-dark">&nbsp; {{ a.NUMEROENVIOSWHATSAPP }}</i>
								<span class="color-black">Enviar trabajos</span>
							</a> -->

                            <a href="#" @click="ReciboConformidad(a.IN_COD_COTIZACIONVEHICULO, a.IDEXTERNO)"
                                data-menu="menu-ReciboConformidad"
                                style="display:inline-flex;align-items:center;gap:6px;background:#f3f4f6;color:#444;font-size:12px;font-weight:600;padding:7px 12px;border-radius:10px;text-decoration:none;">
                                <i class="fa fa-file" style="color:#2f6fd0;"></i> Recibo de Conformidad
                            </a>

                    </div>
                </div>
            </div>

            <!-- Paginado -->
            <div v-if="agenda.length > porPagina" style="display:flex; justify-content:center; align-items:center; gap:12px; padding:14px 0 24px;">
                <a href="#" @click.prevent="cambiarPagina(pagina-1)" class="button button-s bg-blue2-dark round-small shadow-small" :style="pagina<=1 ? 'opacity:0.4; pointer-events:none;' : ''">‹ Anterior</a>
                <span class="bolder">Página {{ pagina }} de {{ totalPaginas }}</span>
                <a href="#" @click.prevent="cambiarPagina(pagina+1)" class="button button-s bg-blue2-dark round-small shadow-small" :style="pagina>=totalPaginas ? 'opacity:0.4; pointer-events:none;' : ''">Siguiente ›</a>
            </div>

        </div>

    </div>
</template>

<script>

    import * as db from "../../database.js";
    import * as validate from "../../validate.js";

    import VueSignaturePad from 'vue-signature-pad';

export default {

    data() {
        return {
            codsucursal: 0,
            sucursal: "",
            resultadoOT: null,
            agenda: [],
            codusuario: 0,
            datasearch: '',
            // Filtros (0 = Todos)
            sucursalSel: 0,
            usuarioSel: 0,
            estadoSel: 0,
            listaSucursales: [],
            listaUsuarios: [],
            listaEstados: [],
            // Paginado
            pagina: 1,
            porPagina: 15
        };
    },

    created() {
        // Recuperar valores del usuario desde localStorage
        const user = JSON.parse(localStorage.getItem('user')) || {};
        this.username = user.nombre || '';
        this.cargo = user.cargo || '';
        this.sucursal = user.sucursal || '';
        this.codsucursal = user.codsucursal || 0;
        this.codusuario = user.codusuario || 0;

        // Formatear la imagen de usuario
        const imageUrl = user.imageurl ? db.getServerHTTP() + user.imageurl : '';
        this.userimageurl = `background-image:url(${imageUrl})`;

        // Recuperar el último valor de búsqueda
        this.datasearch = localStorage.getItem('datasearch') || '';

        // Cargar opciones de filtros (sucursales, usuarios, estados) y la lista
        this.cargarFiltros();
        this.cargarLista();
    },

    computed: {
        // Lista recortada según la página actual (paginado en cliente)
        agendaPaginada() {
            var ini = (this.pagina - 1) * this.porPagina;
            return this.agenda.slice(ini, ini + this.porPagina);
        },
        totalPaginas() {
            return Math.max(1, Math.ceil(this.agenda.length / this.porPagina));
        }
    },

    // El tema pone body{overflow-x:hidden}, que ROMPE position:sticky. Lo cambiamos a
    // 'clip' (oculta el scroll horizontal igual, pero NO rompe sticky) solo en esta
    // pantalla, y lo restauramos al salir.
    mounted() {
        // El tema bloquea position:sticky, así que la fila de filtros va con
        // position:fixed, ubicada justo debajo del header (altura calculada).
        this.$nextTick(() => {
            var h = document.querySelector('.header');
            if (this.$refs.filtroBar) this.$refs.filtroBar.style.top = (h ? h.offsetHeight : 56) + 'px';
        });
    },

    methods: {
        // Lista de OT en estados visibles en la APP (IN_ESTALLERAPP_ESTADOCOTIZACION=1),
        // mías y de mis dependientes (T_ACC_DEPENDIENTE), sin importar sucursal.
        // getQuery devuelve objeto si hay 1 fila y array si hay varias -> normalizamos
        toArray(d) { return d ? (Array.isArray(d) ? d : [d]) : []; },

        // Color automático y estable según el nombre del estado (sin lista en duro).
        // Mismo estado -> mismo color; estados distintos -> colores distintos.
        colorEstado(txt) {
            var s = (txt || '').toString().trim().toUpperCase();
            if (!s) return '#777';
            var h = 0;
            for (var i = 0; i < s.length; i++) { h = (h * 31 + s.charCodeAt(i)) % 360; }
            return 'hsl(' + h + ', 60%, 40%)'; // 40% de luminosidad: texto blanco legible
        },

        cargarLista() {
            var me = this.codusuario;
            var search = (this.datasearch || '').toString().trim();
            var num = parseInt(search, 10);

            var strSql = "SELECT COT.IN_COD_COTIZACIONVEHICULO,"
                + "COT.ST_IDEXTERNO_COTIZACIONVEHICULO IDEXTERNO,"
                + "ISNULL(CLI.ST_NOMBRE_CLIENTE,'')+' '+ISNULL(CLI.ST_APEPAT_CLIENTE,'') CLIENTEAGENDA,"
                + "V.ST_PLACAPATENTE_VEHICULO PLACAPATENTE,"
                + "CONVERT(VARCHAR(10),COT.DT_FECHAINGRESO_COTIZACIONVEHICULO,103) FECHAINGRESO,"
                + "(SELECT ST_DESC_DETALLECLASIFICACION FROM T_GEN_DETALLECLASIFICACION WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL1_VEHICULO) MARCA,"
                + "(SELECT ST_DESC_DETALLECLASIFICACION FROM T_GEN_DETALLECLASIFICACION WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL2_VEHICULO) MODELO,"
                + "(SELECT ST_DESC_DETALLECLASIFICACION FROM T_GEN_DETALLECLASIFICACION WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL3_VEHICULO) VERSION,"
                + "(SELECT ST_NOMBRE_USUARIO+' '+ST_APEPAT_USUARIO FROM T_ACC_USUARIO WHERE IN_COD_USUARIO=COT.IN_COD_USUARIO) USUARIO,"
                + "(SELECT ST_DESC_SUCURSAL FROM T_GEN_SUCURSAL WHERE IN_COD_SUCURSAL=COT.IN_COD_SUCURSAL) SUCURSAL,"
                + "(SELECT ST_DESC_ESTADOCOTIZACION FROM T_VEH_ESTADOCOTIZACION WHERE IN_COD_ESTADOCOTIZACION=COT.IN_ESTADO_COTIZACIONVEHICULO) ESTADO"
                + " FROM T_VEH_COTIZACIONVEHICULO COT,T_CLI_CLIENTE CLI,T_VEH_VEHICULO V"
                + " WHERE COT.IN_COD_CLIENTE=CLI.IN_COD_CLIENTE"
                + " AND COT.IN_COD_VEHICULO=V.IN_COD_VEHICULO";

            if (search && !isNaN(num)) {
                // BUSCAR POR N° DE OT: directo por número (ignora filtros y estados, para encontrarla siempre)
                strSql += " AND COT.IN_COD_COTIZACIONVEHICULO=" + num;
            } else {
                // Lista normal: estados visibles en la APP, mías + dependientes, con filtros
                var fEstado = (this.estadoSel > 0)
                    ? " AND COT.IN_ESTADO_COTIZACIONVEHICULO=" + this.estadoSel
                    : " AND COT.IN_ESTADO_COTIZACIONVEHICULO IN (SELECT IN_COD_ESTADOCOTIZACION FROM T_VEH_ESTADOCOTIZACION WHERE IN_ESTALLERAPP_ESTADOCOTIZACION=1)";
                var fUsuario = (this.usuarioSel > 0)
                    ? " AND COT.IN_COD_USUARIO=" + this.usuarioSel
                    : " AND (COT.IN_COD_USUARIO=" + me + " OR COT.IN_COD_USUARIO IN (SELECT IN_CODUSUARIO_DEPENDIENTE FROM T_ACC_DEPENDIENTE WHERE IN_COD_USUARIO=" + me + "))";
                var fSucursal = (this.sucursalSel > 0) ? " AND COT.IN_COD_SUCURSAL=" + this.sucursalSel : "";
                strSql += fEstado + fUsuario + fSucursal;
            }
            strSql += " ORDER BY COT.DT_FECHAINGRESO_COTIZACIONVEHICULO DESC";

            db.getQuery(strSql).then(result => { if (result.data.err != "") { this.agenda = []; this.pagina = 1; console.log("BuscarOT (sin resultados o error):", result.data.err); } else { this.agenda = this.toArray(result.data.data); this.pagina = 1; } });
        },

        // Carga las opciones de los 3 filtros
        cargarFiltros() {
            // Sucursales que se usan en taller
            db.getQuery("SELECT IN_COD_SUCURSAL COD, ST_DESC_SUCURSAL DESCRIP FROM T_GEN_SUCURSAL WHERE IN_ESUTILIZADATALLER_SUCURSAL=1 ORDER BY ST_DESC_SUCURSAL")
                .then(r => { if (r.data.err == "") this.listaSucursales = this.toArray(r.data.data); });
            // Estados visibles en la APP (columna IN_ESTALLERAPP_ESTADOCOTIZACION)
            db.getQuery("SELECT IN_COD_ESTADOCOTIZACION COD, ST_DESC_ESTADOCOTIZACION DESCRIP FROM T_VEH_ESTADOCOTIZACION WHERE IN_ESTALLERAPP_ESTADOCOTIZACION=1 ORDER BY ST_DESC_ESTADOCOTIZACION")
                .then(r => { if (r.data.err == "") this.listaEstados = this.toArray(r.data.data); });
            // Usuarios (yo + dependientes), filtrados por sucursal (cascada)
            this.cargarUsuarios();
        },

        // Carga usuarios: yo + mis dependientes, y si hay sucursal elegida, solo los de esa sucursal
        cargarUsuarios() {
            var me = this.codusuario;
            var fSuc = (this.sucursalSel > 0) ? " AND IN_COD_SUCURSAL=" + this.sucursalSel : "";
            db.getQuery("SELECT IN_COD_USUARIO COD, ST_NOMBRE_USUARIO+' '+ST_APEPAT_USUARIO DESCRIP FROM T_ACC_USUARIO WHERE (IN_COD_USUARIO=" + me + " OR IN_COD_USUARIO IN (SELECT IN_CODUSUARIO_DEPENDIENTE FROM T_ACC_DEPENDIENTE WHERE IN_COD_USUARIO=" + me + "))" + fSuc + " ORDER BY ST_NOMBRE_USUARIO")
                .then(r => { if (r.data.err == "") this.listaUsuarios = this.toArray(r.data.data); });
        },

        // Al cambiar la sucursal: recarga usuarios de esa sucursal (cascada) + la lista
        cambioSucursal() {
            this.usuarioSel = 0;
            this.cargarUsuarios();
            this.cargarLista();
        },

        aplicarFiltros() { this.cargarLista(); },

        cambiarPagina(n) {
            if (n >= 1 && n <= this.totalPaginas) {
                this.pagina = n;
                window.scrollTo(0, 0);
            }
        },

        buscarOT() {
            // Usa la misma consulta que la lista (cargarLista detecta el N° de OT)
            localStorage.setItem('datasearch', this.datasearch || '');
            this.pagina = 1;
            this.cargarLista();
        },

        VerImagenesOT(id) {
            localStorage.setItem('idcotizacionvehiculo', id)
            localStorage.setItem('datasearch', this.datasearch);
            window.location = '/ImagenesOT';
        },

        VerOTInterna(id){

            var url = db.getServerHTTP();

            if (url == "http://puente.xxi.cl/") {
                url = "https://xxi.netcar.cl";
            }

            if (url == "http://puente.valenzueladelarze.cl/") {
                url = "http://vyd.netcar.cl";
            }

            if (url.startsWith("https://preproduccionxxi.netcar.cl/")){
				url = db.getServerHTTP() + "resources/_netcarsiglo21com/taller/tlrShowOTInterna.aspx?id=" + id + "&file="+this.idFile+"'";
			}

            window.open(db.getReportBase() + "tlrShowOTInterna.aspx?id=" + id + "&file=" + this.idFile, "_blank");
        },

        ImprimirOT(id){
            // Reporte por cliente desde config.json (las ramas de abajo quedan inactivas)
            var url = db.getReportBase()+"tlrShowOT2.aspx?id="+id+"&file="+this.idFile;

            if (url == "http://puente.xxi.cl/") {
                url = "https://xxi.netcar.cl/taller/tlrShowOT2.aspx?id="+ id + "&file=" + this.idFile + "'";
            }

            if (url == "http://puente.valenzueladelarze.cl/") {
                url = "http://vyd.netcar.cl/taller/tlrShowOT2.aspx?id="+ id + "&file=" + this.idFile + "'";
            }

            if (url.startsWith("https://preproduccionxxi.netcar.cl/")){
				url = db.getServerHTTP() + "resources/_netcarsiglo21com/taller/tlrShowOT2.aspx?id=" + id + "&file="+this.idFile+"'";
			}

            window.open(url, "_blank");

        },

        ReciboConformidad(id, idExterno) {
            localStorage.setItem('idcotizacionvehiculoReciboConformidad', id);
            localStorage.setItem('idExternoReciboConformidad', idExterno);
            localStorage.setItem('datasearch', this.datasearch);
            localStorage.setItem('PaginaVolver', "/BuscarOT");
            window.location = "/ReciboConformidad"
        },

    }
}

</script>